import React, { FunctionComponent, ReactNode } from 'react';
import styled, { useTheme } from 'styled-components';
import Tooltip from 'rc-tooltip';

const TooltipContent = styled.div`
  p {
    margin: 0.5em 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const StyledTooltipIcon = styled.i`
  font-size: 1rem;
  cursor: help;
  color: ${props => props.theme.colors.primaryAccent};
`;

export const TooltipIcon: FunctionComponent<{ tooltip: ReactNode; label?: string }> = props => {
  const theme = useTheme();
  return (
    <Tooltip
      overlay={<TooltipContent>{props.tooltip}</TooltipContent>}
      overlayStyle={{ maxWidth: '30%' }}
    >
      <StyledTooltipIcon
        className="fas fa-question-circle"
        style={{ top: props.label && theme.name === 'gogurt' ? '54%' : '34%' }}
      />
    </Tooltip>
  );
};
